import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  supplierFrom: string;     // supplier code lower bound
  supplierTo: string;       // supplier code upper bound
  dateFrom: string;         // entry date lower bound (YYYY-MM-DD)
  dateTo: string;           // entry date upper bound (YYYY-MM-DD)
  deptFrom: string;         // department code lower bound
  deptTo: string;           // department code upper bound
  balanceFilter: number;    // 1=show all, 2=only non-zero balance
  includeUnapproved: boolean; // include unapproved documents
  reportType: string;       // "supplier"|"dept"|"buyer"|"memo"
}

export interface APDetailRow {
  supplierCode: string;
  supplierName: string;
  deptCode: string;
  deptName: string;
  buyerCode: string;
  buyerName: string;
  entryNo: string;
  entryDate: string | null;
  amountDue: number;
  docNo: string;
  docType: string;
  docTypeName: string;
  payAmount: number;
  balance: number;
  accountCode: string;
  typeCode: string;
  exchangeRate: number;
  memo: string;
  markFlag: string;
}

export interface APSummaryRow {
  groupKey: string;
  groupName: string;
  accountCode: string;
  totalDue: number;
  totalPaid: number;
  totalBalance: number;
}

export interface QueryResponse {
  details: APDetailRow[];
  summaries: APSummaryRow[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const h301Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/h301/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/h301/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
